import React, { useState }  from 'react'
import { Link } from 'react-router-dom'
import { Skeleton, } from "@chakra-ui/react"
import Moment from 'moment';
export default function BlogPost(props) {
    const post = props.post;
    const [isloaded, imageLoad] = useState(false);
    const imageStyle = !isloaded ? { display: "none" } : {};
    const placeholder = !isloaded ?<Skeleton height="40vh" width="100%"  />:null
    return (
        <div className="col-lg-6 col-md-6 col-sm-6">
            <div className="single-blog">
            {placeholder}
                <img src={post.image} alt="Blog" style={imageStyle}  onLoad={imageLoad}/>
                <div className="content">
                    <span>{post.categoryByCategory.category + ', ' + Moment(Date(post.date)).format('DD MMMM')}</span>
                    <h3>
                    <Link to={`/blog/posts/${post.id}`}>
                        {post.title}
                    </Link>
                    </h3>
                    <Link to={`/blog/posts/${post.id}`} className="blog-btn">Read more +</Link>
                </div>
            </div>
        </div>
    )
}
